const { foz_chapeco: FozChapeco } = window.SIMBAR;

export const GROUP_NAME = FozChapeco.group;
export const SOURCE = FozChapeco.source;
export const HOME_ROUTE_NAME = "foz_chapeco";
export const TITLE = "Foz do Chapecó";
export const RTS_IMAGE = require("@/assets/images/foz_chapeco/rts_labeled.jpg");
export const SENSOR_UNITS = FozChapeco.sensor_units;
export const SENSOR_LABELS = FozChapeco.sensor_labels;
export const SPECIAL_PERMISSIONS = FozChapeco.special_permissions;
